<script lang="ts">
  import { onDestroy, tick } from "svelte";
  import { fadeSlide } from "../utils/transition";
  import { circInOut } from "svelte/easing";
  import type { Control } from "./controls";
  import { scrollToCenter } from "./utils";

  export let control: Control;
  export let mode: "default" | "alert" = "default";

  // trigger change detection:
  control.changes.subscribe(() => (control = control));

  $: showErrors = control && control.errors.length;

  let element: HTMLDivElement;
  const unsub = control.scrollToErrorsChanges.subscribe(async () => {
    await tick();
    if (element) {
      scrollToCenter(element);
    }
  });

  onDestroy(() => {
    unsub();
  });
</script>

<!-- 
    The div is necessary here becuase svelte compiler 
    produces broken transitions in some complex cases 
    if the if statement is on top level
 -->
<div>
  {#if showErrors}
    <div bind:this={element} class="input-formfield-errors {mode == "alert" ? "alert scom-alert-danger" : "default"}" transition:fadeSlide={{ duration: 250, easing: circInOut }}>
      {#each control.errors as error}
        <div class="input-formfield-error" data-validator={error.validator}>
          {#each error.message?.split("\n") || [] as line}
            <div>{line}</div>
          {/each}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style lang="scss" global>
  .input-formfield-errors {
    scroll-margin-top: 100px;

    &.default {
      color: red;
      text-align: center;
    }

    &.alert {
      border-radius: 28px;
      border-width: 2px;
    }
  }
  .input-formfield-error {
    padding: 0.1em;
  }
</style>
